{
  "scheduling": "अपॉइंटमेंट शेड्यूलिंग",
  "date": "तिथि",
  "time": "समय",
  "duration": "अवधि",
  "provider": "चिकित्सक",
  "reason": "कारण",
  "status": "स्थिति",
  "statusOptions": {
    "scheduled": "निर्धारित",
    "confirmed": "पुष्टि हुई",
    "arrived": "पहुँच गए",
    "checked-in": "चेक इन हुआ",
    "in-progress": "प्रगति में",
    "completed": "पूर्ण",
    "cancelled": "रद्द",
    "no-show": "अनुपस्थित"
  },
  "coverageScope": {
    "panel": "रोगी पैनल",
    "unit": "इकाई",
    "facility": "पूरी सुविधा"
  },
  "coverageScopeDescription": {
    "panel": "केवल कवर किए गए चिकित्सक का रोगी पैनल।",
    "unit": "कवर किए गए चिकित्सक की निर्धारित इकाई।",
    "facility": "पूरी सुविधा — आमतौर पर ऑन-कॉल व्यवस्था।"
  },
  "dayShort": {
    "0": "रवि",
    "1": "सोम",
    "2": "मंगल",
    "3": "बुध",
    "4": "गुरु",
    "5": "शुक्र",
    "6": "शनि"
  },
  "blockType": {
    "available": "उपलब्ध",
    "blocked": "अवरुद्ध"
  },
  "appointmentTypes": {
    "followUp": "अनुवर्ती",
    "newPatient": "नया रोगी",
    "consultation": "परामर्श",
    "procedure": "प्रक्रिया",
    "urgent": "अत्यावश्यक",
    "wellnessCheck": "स्वास्थ्य जाँच",
    "physical": "शारीरिक परीक्षण",
    "telemedicine": "टेलीमेडिसिन",
    "scheduleTemplate": "शेड्यूल टेम्पलेट"
  },
  "pages": {
    "providerDirectory": {
      "title": "चिकित्सक निर्देशिका",
      "subtitle": "स्वास्थ्य सेवा प्रदाताओं को ब्राउज़ करें और खोजें",
      "search": {
        "namePlaceholder": "नाम से खोजें...",
        "specialtyPlaceholder": "विशेषज्ञता से खोजें..."
      },
      "filters": {
        "facilityAriaLabel": "सुविधा के अनुसार फ़िल्टर करें",
        "departmentAriaLabel": "विभाग के अनुसार फ़िल्टर करें",
        "allFacilities": "सभी सुविधाएँ",
        "allDepartments": "सभी विभाग"
      },
      "loading": "चिकित्सकों को लोड किया जा रहा है...",
      "loadError": "चिकित्सक निर्देशिका लोड नहीं हो सकी।",
      "empty": "आपके मानदंडों से मेल खाने वाला कोई चिकित्सक नहीं मिला।",
      "npiLabel": "NPI:"
    },
    "scheduleTemplateForm": {
      "title": "शेड्यूल टेम्पलेट बनाएं",
      "labels": {
        "provider": "चिकित्सक",
        "dayOfWeek": "सप्ताह का दिन",
        "startTime": "प्रारंभ समय",
        "endTime": "समाप्ति समय",
        "slotDuration": "स्लॉट अवधि (मिनट)",
        "templateName": "टेम्पलेट नाम",
        "effectiveStartDate": "प्रभावी तिथि"
      },
      "slotDurationOption": "{{minutes}} मिनट",
      "buttons": {
        "cancel": "रद्द करें",
        "save": "टेम्पलेट सहेजें"
      },
      "toast": {
        "success": "शेड्यूल टेम्पलेट सहेजा गया",
        "failure": "शेड्यूल टेम्पलेट सहेजने में विफल"
      },
      "placeholders": {
        "templateName": "उदा. सोमवार सुबह क्लिनिक"
      },
      "defaultName": "{{day}} शेड्यूल"
    },
    "scheduleManagement": {
      "title": "शेड्यूल प्रबंधन",
      "backToDashboard": "← डैशबोर्ड",
      "newTemplate": "नया टेम्पलेट",
      "today": "आज",
      "blockTooltip": "{{start}} - {{end}} ({{state}})",
      "slotsLabel": "{{minutes}} मिनट के स्लॉट",
      "legend": {
        "booked": "बुक किया गया"
      },
      "upcomingAppointmentsHeading": "आगामी अपॉइंटमेंट - {{providerName}}",
      "loadingAppointments": "अपॉइंटमेंट लोड हो रहे हैं...",
      "unknownPatient": "अज्ञात रोगी",
      "fallbackAppointmentType": "सामान्य",
      "noUpcomingAppointments": "इस चिकित्सक के लिए कोई आगामी अपॉइंटमेंट नहीं है"
    },
    "providerCoverage": {
      "title": "चिकित्सक कवरेज",
      "subtitle": "समय-सीमित शिफ्ट कवरेज — एक निर्धारित अवधि के लिए अपने रोगी पैनल को सहयोगी को सौंपें। ब्रेक-ग्लास से अलग; अवकाश, ऑन-कॉल रोटेशन और नियोजित अनुपस्थिति के लिए उपयोग किया जाता है।",
      "actions": {
        "newCoverage": "नई कवरेज",
        "cancel": "रद्द करें"
      },
      "form": {
        "title": "नई कवरेज व्यवस्था",
        "labels": {
          "coveredProviderId": "कवर किया गया चिकित्सक",
          "coveringProviderId": "कवर करने वाला चिकित्सक",
          "scope": "दायरा",
          "from": "से",
          "until": "तक",
          "reason": "कारण"
        },
        "placeholders": {
          "coveredProviderId": "वह चिकित्सक जिसके पैनल को कवर किया जा रहा है",
          "coveringProviderId": "उस अवधि के लिए कार्यभार संभालने वाला चिकित्सक",
          "reason": "उदा. 22–29 अप्रैल वार्षिक अवकाश; सप्ताहांत ऑन-कॉल कवर"
        },
        "help": {
          "coveredProviderId": "COVERAGE_ADMIN के बिना, यह आप स्वयं होने चाहिए।",
          "coveringProviderId": "नाम से खोजें और चुनें — टाइप की गई आईडी पर कभी कवरेज नहीं दिया जाता।"
        },
        "aria": {
          "effectiveFromDate": "प्रभावी-से तिथि",
          "effectiveFromTime": "प्रभावी-से समय",
          "effectiveUntilDate": "प्रभावी-तक तिथि",
          "effectiveUntilTime": "प्रभावी-तक समय"
        },
        "buttons": {
          "cancel": "रद्द करें",
          "create": "कवरेज बनाएँ"
        },
        "typeaheadEmpty": "कोई चिकित्सक नहीं मिला"
      },
      "sections": {
        "mine": {
          "title": "मेरी कवरेज",
          "subtitle": "वे कवरेज जहाँ मैं कवर करने वाला या कवर किया गया चिकित्सक हूँ।",
          "empty": "कोई कवरेज दर्ज नहीं है।"
        },
        "all": {
          "title": "सभी कवरेज",
          "subtitle": "संगठन में हर कवरेज व्यवस्था। व्यवस्थापक दृश्य।",
          "empty": "कहीं भी कोई कवरेज नहीं। यह या तो बहुत अच्छी ख़बर है या पुराना फ़िल्टर।"
        }
      },
      "list": {
        "coveringConnector": "कवर कर रहे हैं",
        "groups": {
          "active": "सक्रिय ({{count}})",
          "planned": "नियोजित / अतीत ({{count}})",
          "revoked": "रद्द ({{count}})"
        },
        "untilRevoked": "रद्द होने तक",
        "revokedPrefix": "रद्द",
        "revokeTitle": "रद्द करें"
      },
      "revokeDialog": {
        "title": "कवरेज रद्द करें?",
        "description": "{{coveringProviderName}} अब {{coveredProviderName}} को कवर नहीं करेंगे। रिकॉर्ड ऑडिट ट्रेल में बना रहता है।",
        "confirm": "रद्द करें",
        "reasonPlaceholder": "यह कवरेज क्यों समाप्त हो रहा है? (वैकल्पिक)"
      },
      "toast": {
        "created": "कवरेज बनाई गई",
        "revoked": "कवरेज रद्द की गई",
        "invalid": "अमान्य कवरेज — चिकित्सकों और तिथियों की जाँच करें",
        "forbidden": "इस चिकित्सक के लिए कवरेज बनाने की अनुमति नहीं है",
        "createFailed": "कवरेज बनाने में विफल",
        "revokeFailed": "कवरेज रद्द करने में विफल"
      }
    },
    "appointments": {
      "title": "अपॉइंटमेंट",
      "subtitle": "रोगी अपॉइंटमेंट शेड्यूल करें और प्रबंधित करें",
      "actions": {
        "refresh": "रिफ़्रेश",
        "schedule": "अपॉइंटमेंट शेड्यूल करें",
        "arriveTitle": "आगमन दर्ज करें",
        "arriveAria": "{{patientName}} का आगमन दर्ज करें",
        "checkInTitle": "चेक इन",
        "checkInAria": "{{patientName}} को चेक इन करें",
        "rescheduleTitle": "पुनर्निर्धारित करें",
        "rescheduleAria": "{{patientName}} को पुनर्निर्धारित करें",
        "cancelTitle": "रद्द",
        "cancelAria": "{{patientName}} का अपॉइंटमेंट रद्द करें",
        "checkedInLabel": "चेक इन हुआ",
        "startVisitTitle": "विज़िट शुरू करें",
        "startVisitAria": "{{patientName}} की विज़िट शुरू करें"
      },
      "weekNav": {
        "previous": "पिछला सप्ताह",
        "previousAria": "पिछला सप्ताह",
        "next": "अगला सप्ताह",
        "nextAria": "अगला सप्ताह"
      },
      "calendar": {
        "gridAria": "साप्ताहिक अपॉइंटमेंट कैलेंडर",
        "timeColumn": "समय",
        "loading": "शेड्यूल लोड हो रहा है...",
        "cellAria": "{{dayLabel}} {{date}} {{time}} पर",
        "cellTitle": "{{patientName}} - {{appointmentType}} ({{status}})"
      },
      "upcoming": {
        "heading": "आगामी अपॉइंटमेंट",
        "empty": "इस सप्ताह कोई अपॉइंटमेंट नहीं मिली",
        "durationMinutes": "{{minutes}} मिनट",
        "columns": {
          "dateTime": "तिथि / समय",
          "patient": "रोगी",
          "type": "प्रकार",
          "provider": "चिकित्सक",
          "duration": "अवधि",
          "status": "स्थिति",
          "actions": "क्रियाएँ"
        }
      },
      "toast": {
        "cancelled": "अपॉइंटमेंट रद्द",
        "cancelFailed": "अपॉइंटमेंट रद्द करने में विफल",
        "visitStarted": "विज़िट शुरू हुई",
        "startVisitFailed": "विज़िट शुरू करने में विफल",
        "arrivalRecorded": "आगमन दर्ज हुआ",
        "arrivalFailed": "आगमन दर्ज करने में विफल"
      }
    },
    "appointmentForm": {
      "title": {
        "create": "नई अपॉइंटमेंट निर्धारित करें",
        "edit": "अपॉइंटमेंट पुनर्निर्धारित करें"
      },
      "labels": {
        "patient": "रोगी",
        "appointmentType": "अपॉइंटमेंट प्रकार",
        "provider": "चिकित्सक",
        "scheduledAt": "निर्धारित समय",
        "duration": "अवधि",
        "reason": "विज़िट का कारण"
      },
      "placeholders": {
        "patientSearch": "नाम या MRN से रोगी खोजें...",
        "provider": "चिकित्सक का नाम",
        "reason": "विज़िट का संक्षिप्त कारण..."
      },
      "patientTypeahead": {
        "empty": "कोई रोगी नहीं मिला"
      },
      "aria": {
        "appointmentDate": "अपॉइंटमेंट तिथि",
        "appointmentTime": "अपॉइंटमेंट समय"
      },
      "durationOption": "{{minutes}} मिनट",
      "buttons": {
        "cancel": "रद्द करें",
        "schedule": "अपॉइंटमेंट निर्धारित करें",
        "update": "अपॉइंटमेंट अपडेट करें"
      },
      "toast": {
        "created": "अपॉइंटमेंट सफलतापूर्वक निर्धारित की गई",
        "updated": "अपॉइंटमेंट अपडेट की गई",
        "createFailed": "अपॉइंटमेंट बनाने में विफल",
        "updateFailed": "अपॉइंटमेंट अपडेट करने में विफल"
      },
      "validation": {
        "patientRequired": "कृपया एक रोगी चुनें",
        "appointmentTypeRequired": "अपॉइंटमेंट प्रकार आवश्यक है",
        "scheduledAtRequired": "दिनांक और समय आवश्यक हैं",
        "durationInvalid": "अवधि 1 से 480 मिनट के बीच होनी चाहिए",
        "providerRequired": "कृपया एक चिकित्सक चुनें"
      },
      "providerTypeahead": {
        "empty": "कोई चिकित्सक नहीं मिला"
      },
      "loadingEdit": "अपॉइंटमेंट लोड हो रहा है…",
      "loadEditError": "यह अपॉइंटमेंट लोड नहीं हो सका।",
      "patientLocked": "पुनर्निर्धारण करते समय रोगी को बदला नहीं जा सकता।"
    },
    "waitlist": {
      "title": "अपॉइंटमेंट प्रतीक्षा सूची",
      "backToDashboard": "← डैशबोर्ड",
      "entryCount": "{{count}} प्रविष्टियाँ",
      "searchPlaceholder": "मरीज का नाम, MRN या नोट खोजें...",
      "clearSearchAria": "खोज साफ़ करें",
      "filters": {
        "allProviders": "सभी चिकित्सक",
        "allTypes": "सभी प्रकार",
        "providerAriaLabel": "चिकित्सक के अनुसार फ़िल्टर",
        "typeAriaLabel": "अपॉइंटमेंट प्रकार के अनुसार फ़िल्टर"
      },
      "columns": {
        "patient": "मरीज",
        "provider": "चिकित्सक",
        "type": "प्रकार",
        "priority": "प्राथमिकता",
        "requestedDates": "अनुरोधित तिथियाँ",
        "dateAdded": "जोड़ने की तिथि",
        "notes": "नोट्स",
        "actions": "कार्रवाई",
        "reason": "कारण"
      },
      "priority": {
        "urgent": "तत्काल",
        "routine": "नियमित",
        "flexible": "लचीला"
      },
      "actions": {
        "scheduleTitle": "अपॉइंटमेंट निर्धारित करें",
        "editPriorityTitle": "प्राथमिकता संपादित करें",
        "removeTitle": "प्रतीक्षा सूची से हटाएँ"
      },
      "empty": "आपके फ़िल्टर से मेल खाने वाली कोई प्रतीक्षा सूची प्रविष्टि नहीं है",
      "loadFailed": "प्रतीक्षा सूची लोड नहीं हो सकी। अपना कनेक्शन जांचें और पुनः प्रयास करें।",
      "modal": {
        "title": "अपॉइंटमेंट निर्धारित करें",
        "closeAria": "बंद करें",
        "providerLabel": "चिकित्सक:",
        "requestedLabel": "अनुरोध:",
        "dateTimeLabel": "अपॉइंटमेंट तिथि और समय *",
        "dateAria": "अपॉइंटमेंट तिथि",
        "timeAria": "अपॉइंटमेंट समय",
        "requestedWindow": "अनुरोधित अवधि: {{start}} — {{end}}",
        "cancel": "रद्द करें",
        "submit": "निर्धारित करें"
      },
      "toasts": {
        "removed": "प्रविष्टि प्रतीक्षा सूची से हटाई गई",
        "priorityUpdated": "प्राथमिकता अद्यतन की गई",
        "scheduled": "अपॉइंटमेंट निर्धारित और प्रतीक्षा सूची से हटाया गया",
        "dateTimeRequired": "कृपया तिथि और समय चुनें",
        "updateFailed": "प्रतीक्षा सूची अपडेट करने में विफल",
        "promoteOrphaned": "अपॉइंटमेंट बन गया, लेकिन प्रतीक्षा सूची प्रविष्टि अपडेट नहीं हो सकी। पुनः प्रयास से पहले शेड्यूल जांचें।"
      }
    },
    "checkIn": {
      "title": "रोगी चेक इन करें",
      "subtitle": "पंजीकरण — बीमा, प्राधिकरण और सह-भुगतान। रोगी पहुँच चुका है।",
      "fields": {
        "insuranceId": "बीमा",
        "copayAmount": "सह-भुगतान राशि",
        "copayCollected": "सह-भुगतान लिया गया",
        "authorizationNumber": "प्राधिकरण संख्या",
        "authorizationVerified": "प्राधिकरण सत्यापित"
      },
      "copayHint": "सह-भुगतान लिया गया चिह्नित करने पर रोगी के खाते में भुगतान दर्ज होता है।",
      "submit": "चेक-इन पूरा करें",
      "cancel": "रद्द करें",
      "toast": {
        "success": "रोगी चेक इन हुआ",
        "failed": "रोगी को चेक इन करने में विफल"
      }
    },
    "providerTypeahead": {
      "loadError": "चिकित्सक निर्देशिका उपलब्ध नहीं है — अपना कनेक्शन जांचें और पुनः प्रयास करें।",
      "retry": "पुनः प्रयास"
    }
  }
}
